import {getActionType, TYPES} from '../util/redux';
import {InsType} from '../action/ins';

const initState = {
    request : false,
    supports : [],
    msg : '',
    query_request : false,
    way : 0, //文件上传， 1填写视频信息
    progress: 0
}
const type1 = getActionType(InsType, 'request');
const type2 = getActionType(InsType, 'success');
const type3 = getActionType(InsType, 'fail');
const type4 = getActionType(InsType, 'clear');
const type5 = getActionType(InsType, 'qrrequest');  //查询链接是否有效
const type6 = getActionType(InsType, 'qycomplete');  //qrrequest返回
const type7 = getActionType(InsType, 'editstep');
const type8 = getActionType(InsType, 'editprogress');

export default function insReducer(state = initState, action){
    let {type, payload} = action;
    switch(type){
        case type1:
            return {
                ...state,
                request : true,
                msg : ''
            }
        case type2:
            let result = payload.data || {};
            let sites = result.sites || [];
            return {
                ...state,
                request : false,
                supports : sites,
                size : result.size,
                msg : ''
            }
        case type3:
            let rcode = payload.code;
            let rmsg = payload.msg;
            return {
                ...state,
                request : false,
                msg : rmsg
            }
        case type5:
            return {
                ...state,
                query_request : true
            }
        case type6:
            let nstep = state.way;
            if(payload.success){
                nstep = 1;
            }
            return {
                ...state,
                way : nstep,
                query_request : false
            }
        case type7:
            let cstep = payload.way || 0;
            return {
                ...state,
                way : cstep
            }
        case type8:
            let cprogress = paylod.progress || 0;
            return {
                ...state,
                progress: cprogress
            }
        case TYPES.CLEAR_ALL:case type4:
            return {
                ...initState
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./client/reducers/ins.js